import React, { useCallback } from 'react';
import { Community, CommunityDetails } from 'store/types/Community';
import Modal from 'components/shared/Modal';
import { ModalProps } from 'store/types/ComponentProps';
import CopyInput from 'components/shared/CopyInput';
import { defaultGridContainerProps, defaultGridItemProps } from 'util/Layout';
import { Divider, Grid } from '@mui/material';
import CommitteeService from 'services/api/CommitteeService';
import useRequest from 'hooks/useRequest';
import Alert from '@mui/material/Alert';
import routes from 'store/configs/Routes';
import CommunityMembersSection from 'components/communities/CommunityMembersSection';

import commonStyles from 'styles/common.module.scss';
import styles from './PublicCommitteeModal.module.scss';

interface PublicCommitteeModalProps extends ModalProps {
  data: Community;
}

const PublicCommitteeModal: React.FunctionComponent<PublicCommitteeModalProps> = ({ data, open, onClose }) => {
  const { id, name, description, roles } = data;
  const committeeDetailsRequest = useCallback(() => CommitteeService.getCommitteeDetails(id, true), [id]);
  const committeeDetailsRequestData = useRequest<CommunityDetails>(committeeDetailsRequest);
  const { data: committeeDetailsData, loading, error } = committeeDetailsRequestData;

  return (
    <Modal loading={loading} open={open} onClose={onClose} title={'Committee Details'} maxWidth={'lg'}>
      {error ? (
        <Alert severity={'error'} className={commonStyles.alert}>
          {error}
        </Alert>
      ) : (
        <Grid {...defaultGridContainerProps} spacing={3}>
          <Grid {...defaultGridItemProps}>
            <h2 className={styles.title}>{name}</h2>
          </Grid>
          <Divider className={styles.divider} />
          {description && (
            <Grid {...defaultGridItemProps}>
              <p className={commonStyles.text}>{description}</p>
            </Grid>
          )}
          <Grid {...defaultGridItemProps} sm={6}>
            <h3 className={commonStyles.subTitle}>{'Copy the link to share the committee'}</h3>
            <CopyInput link={`${window.location.origin}/#${routes.publicCommittees}?detailsId=${id}`} />
          </Grid>
          <Grid {...defaultGridItemProps}>
            <CommunityMembersSection
              {...committeeDetailsRequestData}
              data={committeeDetailsData?.members}
              communityName={name}
              roles={roles}
              communityId={id}
              description={'The list of committee members.'}
            />
          </Grid>
        </Grid>
      )}
    </Modal>
  );
};
export default PublicCommitteeModal;
